import { render, staticRenderFns } from "./gacChat.vue?vue&type=template&id=53731764"
import script from "./gacChat.vue?vue&type=script&lang=js"
export * from "./gacChat.vue?vue&type=script&lang=js"
import style0 from "./gacChat.vue?vue&type=style&index=0&id=53731764&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports